const crypto = require('crypto');

class MemoryStore {
    constructor() {
        this.sessions = new Map();
    }
    async get(sid) {
        return this.sessions.get(sid);
    }
    async set(sid, data, ttl) {
        this.sessions.set(sid, data);

        setTimeout(() => this.sessions.delete(sid), ttl * 1000).unref();
    }
    async destroy(sid) {
        this.sessions.delete(sid);
    }
}

class RedisStore {
    constructor(redisClient) {
        this.client = redisClient;
    }
    async get(sid) {
        const data = await this.client.get(`session:${sid}`);
        return data ? JSON.parse(data) : null;
    }
    async set(sid, data, ttl) {
        await this.client.set(`session:${sid}`, JSON.stringify(data), {
            EX: ttl
        });
    }
    async destroy(sid) {
        await this.client.del(`session:${sid}`);
    }
}

function generateSessionId() {
    return crypto.randomBytes(32).toString('hex');
}

module.exports = function createSessionMiddleware(opts) {
    if (!opts || !opts.session) return null;

    const sessionOpts = Object.assign(
        {
            secret: 'fullstx-default-secret',
            store: 'memory',
            redisUrl: 'redis://localhost:6379',
            cookieName: 'fullstx_sid',
            ttl: 86400
        },
        opts.session
    );

    let store;
    if (sessionOpts.store === 'redis') {
        try {
            const { createClient } = require('redis');
            const client = createClient({ url: sessionOpts.redisUrl });
            client.on('error', (err) => console.error('[fullstx] Session Redis Error:', err));
            client.connect().catch((e) => console.error('[fullstx] Session Redis Connect Error:', e));
            store = new RedisStore(client);
            console.log('[fullstx] Session Store: Redis');
        } catch {
            console.warn('[fullstx] Failed to load redis for session, falling back to memory store.');
            store = new MemoryStore();
        }
    } else {
        store = new MemoryStore();
    }

    return async function sessionMiddleware(req, res, next) {
        const sid = req.cookies && req.cookies[sessionOpts.cookieName];
        let sessionData = null;

        if (sid) {
            sessionData = await store.get(sid);
        }

        const currentSid = sid || generateSessionId();

        if (!sessionData) {
            sessionData = {};
        }

        req.session = sessionData;
        req.sessionID = currentSid;

        if (!sid && res.cookie) {
            res.cookie(sessionOpts.cookieName, currentSid, {
                maxAge: sessionOpts.ttl,
                httpOnly: true,
                path: '/'
            });
        }

        const originalEnd = res.end;
        res.end = function (chunk, encoding, callback) {
            store.set(currentSid, req.session, sessionOpts.ttl).catch((err) => {
                console.error('[fullstx] Session Save Error:', err);
            });

            originalEnd.call(res, chunk, encoding, callback);
        };

        next();
    };
};
